// extracted by mini-css-extract-plugin
module.exports = {"base":"Checkbox_base__1gz9H","isActive":"Checkbox_isActive__3aBUS","input":"Checkbox_input__2shVN","label":"Checkbox_label__383WG"};